import React, { Component } from 'react';
import CardSlider from '../../components/blog-cards/CardSlider';
import CardGrid from '../../components/blog-cards/CardGrid';
import arrow from '../../assets/images/icons/arrow-left.svg';
import { api_url, headers } from '../../common/config';
import Video from './Video';
import { withTranslation } from 'react-i18next';
const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2 },
    { width: 768, itemsToShow: 3 },
    { width: 1200, itemsToShow: 5 },
];

const cardStyle = {};

class Videos extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isClicked: false,
            videos: [],
        };
    }

    handleClick = () => {
        this.setState({
            isClicked: true,
        });
    };

    componentDidMount() {
        fetch(
            `${api_url}/autism/items/resources_page_videos?filter[status]=published`,
            {
                method: 'GET',
                // headers: headers,
            }
        )
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    videos: res.data,
                });
            });
    }

    render() {
        let videos = ['', '', '', '', '', '', ''];
        let cards = null;
        if (this.props.videos === null) {
            cards = videos.map((video) => (
                <div
                    className='videos_card'
                    style={{
                        backgroundColor: '#e5edff',
                    }}
                >
                    <div className='play_button'></div>
                    <div className='video_details'>
                        <div className='video_title'></div>
                        <div className='video_duration'></div>
                    </div>
                </div>
            ));
        } else {
            cards = this.props.videos.map((video) => (
                <Video
                    id={video.id}
                    link={video.video_link}
                    title={video.title}
                    body={video.body}
                    image={video.image}
                    status={video.status}
                />
            ));
        }

        const { t } = this.props;
        return (
            <div className='videos_container'>
                {this.props.isGrid ? (
                    <CardGrid arrow={arrow} cards={cards} />
                ) : (
                    <>
                        <div className='title_wrapper'>
                            <h2 className='title'>{t('blog.tabs.videos')}</h2>
                            <button onClick={this.props.showAllBtn}>
                                {t('blog.showAll')}
                            </button>
                        </div>
                        <CardSlider
                            arrow={arrow}
                            cards={cards}
                            size={30}
                            large
                        />
                    </>
                )}
            </div>
        );
    }
}

export default withTranslation()(Videos);
